/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ACLINFO {
    /**
     * Type of object
     */
    objectType: ACLINFO.ObjectTypeEnum;
    /**
     * Id of object, use value \"action\" for setting permission to action and not for a particular object
     */
    objectId: string;
    /**
     * Permission to read object(s)
     */
    read: boolean;
    /**
     * Permission to update object(s)
     */
    update: boolean;
    /**
     * Permission to create & use object(s)
     */
    use: boolean;
    /**
     * Permission to delete object(s)
     */
    _delete: boolean;
    /**
     * true if user can grant this permission to others, false if not
     */
    withGrantOption: boolean;
}
export namespace ACLINFO {
    export type ObjectTypeEnum = 'CARD_GROUP' | 'CARD_GROUP_CREATION' | 'POOL' | 'POOL_CREATION' | 'USER_MANAGEMENT' | 'USER_CREATION' | 'IMPORT' | 'PROFILE' | 'REPORT' | 'SCHEDULED_REPORT';
    export const ObjectTypeEnum = {
        CARDGROUP: 'CARD_GROUP' as ObjectTypeEnum,
        CARDGROUPCREATION: 'CARD_GROUP_CREATION' as ObjectTypeEnum,
        POOL: 'POOL' as ObjectTypeEnum,
        POOLCREATION: 'POOL_CREATION' as ObjectTypeEnum,
        USERMANAGEMENT: 'USER_MANAGEMENT' as ObjectTypeEnum,
        USERCREATION: 'USER_CREATION' as ObjectTypeEnum,
        IMPORT: 'IMPORT' as ObjectTypeEnum,
        PROFILE: 'PROFILE' as ObjectTypeEnum,
        REPORT: 'REPORT' as ObjectTypeEnum,
        SCHEDULEDREPORT: 'SCHEDULED_REPORT' as ObjectTypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/aCLINFO.ts